import React from 'react';
import Text from '../../../text';
import { getYearRageStart } from '../day';
const MonthCalendarTitle = ({ lang, target }) => {
    const start = getYearRageStart(target.year());
    return (React.createElement(Text, { lang: lang, fontType: "Subheading", color: "INK_800" }, `${start} - ${start + 9}`));
};
export default MonthCalendarTitle;
//# sourceMappingURL=YearCalendarTitle.js.map